import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-questionnaire',
    templateUrl: './questionnaire.component.html',
    styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent {
    public questionnaireDataList: unknown[] = [
        {
            "title": "User Questionnaire",
            "url": "https://forms.gle/nhrz1wctgrcwPyes9"
        },
        {
            "title": "Developer Questionnaire",
            "url": "https://forms.gle/qbvDVqjTebr5FrJM6"
        }
    ]
    constructor(
        public questionnaireDialogRef: MatDialogRef<QuestionnaireComponent>
    ) {}

    ngOnInit() {
        this.questionnaireDialogRef.addPanelClass('questionnaire-dialog');
        localStorage.setItem('questionnaireDialogOpened', 'true');
    }

}                